import { HubConnectionState } from '@microsoft/signalr'

import { MutationTree } from 'vuex'

import {
  BusinessUnit,
  DeliverySettings,
  Profile,
  ShopSettings
} from '@/models'

import { RootState } from './state'

export const DECREMENT_MODAL_COUNTER = 'DECREMENT_MODAL_COUNTER'
export const HIDE_NEW_VERSION_NOTIFICATION = 'HIDE_NEW_VERSION_NOTIFICATION'
export const INCREMENT_MODAL_COUNTER = 'INCREMENT_MODAL_COUNTER'
export const SHOW_NEW_VERSION_NOTIFICATION = 'SHOW_NEW_VERSION_NOTIFICATION'
export const UPDATE_DELIVERY_SETTINGS = 'UPDATE_DELIVERY_SETTINGS'
export const UPDATE_BUSINESS_UNIT = 'UPDATE_BUSINESS_UNIT'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_SHOP_SETTINGS = 'UPDATE_SHOP_SETTINGS'
export const UPDATE_WEBSOCKET_STATUS = 'UPDATE_WEBSOCKET_STATUS'

const mutations: MutationTree<RootState> = {
  [DECREMENT_MODAL_COUNTER] (state) {
    state.modalCount -= 1
  },

  [HIDE_NEW_VERSION_NOTIFICATION] (state) {
    state.showNewVersionNotification = false
  },

  [INCREMENT_MODAL_COUNTER] (state) {
    state.modalCount += 1
  },

  [SHOW_NEW_VERSION_NOTIFICATION] (state) {
    state.showNewVersionNotification = true
  },

  [UPDATE_DELIVERY_SETTINGS] (state, deliverySettings: DeliverySettings | null) {
    state.deliverySettings = deliverySettings
  },

  [UPDATE_BUSINESS_UNIT] (state, businessUnit: BusinessUnit | null) {
    state.businessUnit = businessUnit
  },

  [UPDATE_PROFILE] (state, profile: Profile | null) {
    state.profile = profile
  },

  [UPDATE_SHOP_SETTINGS] (state, shopSettings: ShopSettings | null) {
    state.shopSettings = shopSettings
  },

  [UPDATE_WEBSOCKET_STATUS] (state, status: HubConnectionState) {
    state.webSocketStatus = status
  }
}

export default mutations
